import React, { useRef } from 'react';
import { PortalProvider } from '../portal/portal-provider';
import { useThemeProvider } from './use-theme-provider';
/**
 * `<ThemeProvider />` - контейнер для всего приложения, он определяет тему и другие настройки для приложения.
 *
 * ***`ThemeProvider` должен быть корневым элементом Вашего приложения, чтобы гарантировать наследование темы***
 *
 * @example ```jsx
 * <ThemeProvider theme="light">
 *   <App />
 * </ThemeProvider>
 * ```
 */
export function ThemeProvider(props) {
  const {
    children,
    className,
    style
  } = useThemeProvider(props);
  const themeProviderRef = useRef(null);
  return /*#__PURE__*/React.createElement("div", {
    ref: themeProviderRef,
    className: className,
    style: style,
    "data-testid": "theme-provider"
  }, /*#__PURE__*/React.createElement(PortalProvider, {
    value: themeProviderRef
  }, children));
}